import React from 'react';
import PropTypes from 'prop-types';
import { Icon as SemanticIcon } from 'semantic-ui-react';

import {
  Button,
  Input,
  ContainerInput,
  ContainerText,
  Modal,
  Content,
  ContentRow,
  Actions,
  ErrorMessage,
  InputCheckbox,
} from './styles';

const ModalWithInputs = (props) => {
  const {
    open,
    onClose,
    inputs,
    error,
    onSubmit,
    buttonText,
    icon,
    loading,
  } = props;

  const inputElements = Object.entries(inputs).map(([name, {
    value, onChange, inputType, label,
  }]) => (
    <ContentRow key={name}>
      {inputType === 'checkbox' && (
        <ContainerInput>
          <InputCheckbox
            onChange={onChange}
            name="generate-link-checkbox"
            label={label}
            checked={value}
          />
        </ContainerInput>
      )}
      {inputType === 'text' && (
        <>
          <ContainerText as="label" htmlFor="generate-link-text-input">
            {label}
          </ContainerText>
          <ContainerInput>
            <Input
              name="generate-link-text-input"
              onChange={onChange}
              value={value}
            />
          </ContainerInput>
        </>
      )}
    </ContentRow>
  ));

  return (
    <Modal
      size="mini"
      open={open}
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
    >
      <Content>
        {inputElements}
        {error && (
          <ContentRow>
            <ErrorMessage>{error}</ErrorMessage>
          </ContentRow>
        )}
      </Content>
      <Actions>
        <Button loading={loading} onClick={onSubmit}>
          {icon && (<SemanticIcon name={icon} />)}
          {buttonText}
        </Button>
      </Actions>
    </Modal>
  );
};

const inputValueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

ModalWithInputs.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inputs: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: inputValueType,
    inputType: PropTypes.oneOf(['text', 'checkbox']),
  })).isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  buttonText: PropTypes.string,
  icon: PropTypes.string,
};

ModalWithInputs.defaultProps = {
  open: false,
  error: null,
  loading: false,
  buttonText: '',
  icon: null,
};

export default ModalWithInputs;
